module.exports = __webpack_public_path__ + "static/media/essential-oils-chemistry-handbook.d42e984e.png";